/** localStorage key for light/dark preference (must match inline script in index.html). */
export const THEME_STORAGE_KEY = "ai-pos-theme";

export type ThemeMode = "light" | "dark";

export function readStoredTheme(): ThemeMode | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(THEME_STORAGE_KEY);
    if (raw === "light" || raw === "dark") return raw;
  } catch {
    /* ignore */
  }
  return null;
}

export function getSystemTheme(): ThemeMode {
  if (typeof window === "undefined") return "light";
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

export function resolveInitialTheme(): ThemeMode {
  return readStoredTheme() ?? getSystemTheme();
}
